import React, { useState } from 'react';
import styled from 'styled-components';
import EasterEggImg from 'assets/images/home/easter-egg.png';
import { TYPE } from 'theme';
import Modal from 'components/Modal';
import { ColumnCenter } from 'components/Column';
import { ReactComponent as StartSVG } from 'assets/images/home/star.svg';
import Row from 'components/Row';
import { BlurredBox, GradientShadowBox } from 'components/styled/Box';
import Button from 'components/Button';

const Wrapper = styled.div`
    position: relative;
    z-index: 100;
    cursor: pointer;
`;

const Img = styled.img`
    width: 58px;
    height: 58px;
    display: block;
    ${({ theme }) => theme.mediaWidth.upToSmall`
        width: 40px;
        height: 40px;
    `};
`;

const ModalWrapper = styled.div`
    width: 480px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 0px;

    ${({ theme }) => theme.mediaWidth.upToSmall`
        width: 100%;
    `};
`;

const Card = styled.div`
    width: 100%;
    height: 100%;
    background-color: #000;
    border-radius: 20px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin-bottom: 32px;
`;

const UnlockConditions = [
    <div key={0}>
        Reach <b>300,000</b> block hight
    </div>,
    <div key={1}>
        Reach <b>500</b> BTC TVL
    </div>,
    <div key={2}>
        Reach <b>200,000,000</b> transactions
    </div>,
];

const SpecificRewards = [
    <div key={3}>
        Lottery with <b>0.1</b> BTC prize pool.
    </div>,
    <div key={4}>Randomly give 1,000 GEC to 10 users.</div>,
];

const List = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
`;

const ListItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;

    &:not(:last-child) {
        margin-bottom: 10px;
    }
`;

const ListIndex = styled.div`
    width: 24px;
    height: 23px;
    background-color: ${({ theme }) => theme.c.primary01};
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    font-weight: 600;
    font-size: 14px;
`;

const ListContent = styled.div`
    font-size: 14px;
`;

const CloseButton = styled(Button).attrs({
    type: 'unstyled',
    size: 'unset',
})`
    background: ${({ theme }) => theme.c.linearGradientBg};
    width: 100%;
    padding: 20px 40px;
    font-size: 16px;
    font-weight: 600;
    border-radius: 15px;
    cursor: pointer;
    text-align: center;

    ${({ theme }) => theme.mediaWidth.upToSmall`
        font-size: 16px;
        padding: 16px 20px;
    `};
`;

export default function EasterEgg({ title, modalTitle, mask }: { title: string; modalTitle: string; mask: boolean }) {
    const [open, setOpen] = useState(false);

    return (
        <Wrapper>
            <ColumnCenter
                style={{
                    flexDirection: 'row',
                    gap: '6px',
                }}
                onClick={() => setOpen(true)}
            >
                <GradientShadowBox top={-5} right={-5} bottom={-5} left={-5}>
                    <Img src={EasterEggImg} alt="EasterEgg" />
                </GradientShadowBox>
                <TYPE.desc fontSize={16} mobileFz={14}>
                    {title}
                </TYPE.desc>
            </ColumnCenter>

            <Modal isOpen={open} onClose={() => setOpen(false)} shadowProps={true}>
                <ModalWrapper>
                    <Row align="center" gap="8px" marginBottom="20px">
                        <TYPE.main fontSize={20} fontWeight={600} textAlign="center">
                            {modalTitle}
                        </TYPE.main>
                        <StartSVG style={{ width: 42, height: 42 }} />
                    </Row>

                    <Card>
                        <TYPE.main fontSize={16} fontWeight={600} marginBottom="20px">
                            Unlock Conditions:
                        </TYPE.main>

                        <BlurredBox blur={mask ? 4 : false}>
                            <List>
                                {UnlockConditions.map((item, index) => {
                                    return (
                                        <ListItem key={index}>
                                            <ListIndex>{index + 1}</ListIndex>
                                            <ListContent>{item}</ListContent>
                                        </ListItem>
                                    );
                                })}
                            </List>

                            <TYPE.desc fontSize={12} fontWeight={400} marginY="20px">
                                Complete any <b>one of the above three conditions</b> to unlock the Lucky Draw. Once the
                                unlocking criteria are met, all participating users will have a chance to activate the
                                Lucky Draw.
                            </TYPE.desc>
                        </BlurredBox>

                        <TYPE.main fontSize={16} fontWeight={600} marginBottom="20px">
                            Specific Rewards:
                        </TYPE.main>

                        <BlurredBox blur={mask ? 4 : false}>
                            <List>
                                {SpecificRewards.map((item, index) => {
                                    return (
                                        <ListItem key={index}>
                                            <ListIndex>{index + 1}</ListIndex>
                                            <ListContent>{item}</ListContent>
                                        </ListItem>
                                    );
                                })}
                            </List>
                        </BlurredBox>

                        <img
                            src={require('assets/images/home/easter-egg.png')}
                            style={{
                                width: '100px',
                                height: '100px',
                                position: 'absolute',
                                top: '60px',
                                right: '50px',
                            }}
                        />
                    </Card>

                    <CloseButton onClick={() => setOpen(false)}>Close</CloseButton>
                </ModalWrapper>
            </Modal>
        </Wrapper>
    );
}
